import React from 'react';

import styles from './styles.module.css';

export default function SuccessMessage({ onHome }: { onHome?: () => void }) {
  return (
    <div className={styles.container}>
      <div className={styles.iconWrapper}>
        <img src="/email.svg" alt="ícone de e-mail" className={styles.icon} />
      </div>
      <div className={styles.title}>
        Solicitação de exclusão de conta enviada com sucesso!
      </div>
      <div className={styles.subtitle}>
        Recebemos sua solicitação e em breve nossa equipe do SAC entrará em
        contato com você. Agora é só aguardar.
      </div>
      <button className={styles.homeButton} onClick={onHome} type="button">
        Voltar para Home
      </button>
    </div>
  );
}
